import React, { useState } from 'react';

import TextField from '@mui/material/TextField';

export const INVALID_INTEGER_KEYS = ['e', 'E', ',', '.', '-', '+'];

const NumberTextField = ({ name, value, label, onChange, disabled, min, max, invalidKeys = INVALID_INTEGER_KEYS, errorMessage: error, helperText, ...props }) => {
	const [errorMessage, setErrorMessage] = useState('');
	const handleKeyDown = (e) => {
		if (invalidKeys.includes(e.key)) {
			e.preventDefault();
			setErrorMessage('Please enter only whole numbers (no decimals, letters, or commas).');
		}
	};
	const handlePaste = (e) => {
		const pasted = (e.clipboardData?.getData('text') ?? '').trim();
		if (pasted && !/^\d+$/.test(pasted)) {
			e.preventDefault();
			setErrorMessage('Please enter only whole numbers (no decimals, letters, or commas).');
		}
	};
	const handleChange = (v) => {
		if (v === '') {
			// Set the error message back to empty string when user deletes input.
			setErrorMessage('');
			onChange({ target: { name, value: '' } });
			return;
		}
		const valueAsInt = parseInt(v, 10);
		if (min && valueAsInt < min) {
			setErrorMessage(`The provided value is less than the configured minimum: ${min}`);
			onChange({ target: { name, value: valueAsInt } });
			return;
		}
		if (max && valueAsInt > max) {
			setErrorMessage(`The provided value is more than the configured maximum: ${max}`);
			onChange({ target: { name, value: valueAsInt } });
			return;
		}

		onChange({ target: { name, value: valueAsInt } });
		setErrorMessage('');
	};

	return (
		<TextField
			fullWidth
			variant='outlined'
			value={value}
			onChange={({ target: { value } }) => handleChange(value)}
			onKeyDown={handleKeyDown}
			onPaste={handlePaste}
			type='number'
			name={name}
			label={label}
			disabled={disabled}
			inputProps={{ min, max }}
			error={error || errorMessage !== ''}
			helperText={helperText || error || errorMessage}
			{...props}
		/>
	);
};

NumberTextField.type = 'NumberTextField';

export default NumberTextField;
